<template>
  <div>
    <b-list-group
      flush
      class="awaitlist"
    >
      <b-list-group-item
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_TYPE')"
          class="awaitModuleFields"
          label-for="awaitType"
          label-cols-md="4"
        >
          <v-select
            v-model="processModule.module_settings.type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="awaitTypeOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="awaitType"
            disabled
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_DAYS')"
          class="awaitModuleFields"
          label-for="awaitType"
          label-cols-md="4"
        >
          <b-form-input
            v-model="processModule.module_settings.number_of_days"
            placeholder="Days"
            type="number"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_AWAIT_SKIP_INTEREST')"
          class="awaitModuleFields"
          label-for="checkbox-await"
          label-cols-md="4"
        >
          <b-form-checkbox
            id="checkbox-await"
            v-model="processModule.module_settings.skip_interest_calculation"
            class="custom-control-primary"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_SKIP_WEEKEND')"
          class="awaitModuleFields"
          label-for="checkbox-skip-monday"
          label-cols-md="4"
        >
          <b-form-checkbox
            id="checkbox-skip-monday"
            v-model="processModule.module_settings.skip_monday"
            class="custom-control-primary"
          />
        </b-form-group>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import vSelect from 'vue-select'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormInput,
  // BButton,
  // BForm,
  // BRow,
  // BCol,
  // BInputGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, integer } from '@validations'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    // BCardCode,
    // BForm,
    // BRow,
    // BCol,
    BFormGroup,
    // BInputGroup,
    BFormInput,
    // BButton,
    // ValidationProvider,
    // ValidationObserver,
    vSelect,
    BFormCheckbox,
  },
  props: {
    processModule: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      integer,
      awaitType: 0,
      days: '',
      awaitTypeOptions: [
        { label: 'Time Based', value: 1 },
        { label: 'Action Based', value: 2 },
      ],
    }
  },
  created() {
  },
  methods: {
    getAwaitType(type) {
      const awaittype = type === 1 ? 'Time Based' : 'Action Based'
      return awaittype
    },
    validationAwaitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 1,
        module_order: 1,
        number_of_days: Number(this.days),
        type: this.awaitType,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      this.$refs.awaitRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.awaitType = 0
              this.days = ''
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeAwaitModal', returnObj)
            }
          })
        }
      })
    },
  },
}
</script>

  <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .addAwaitBtn {
      width: 100%;
    }

    .awaitModuleFields {
        width: 50%;
        margin: auto;
    }
  </style>
